import { ThemeUIStyleObject } from 'theme-ui';
import styles from './SectionHeader.styles';
export interface SectionHeaderProps {
  title: string;
  className?: string;
  sx?: ThemeUIStyleObject;
}
const SectionHeader = ({
  title,
  className,
  sx
}: SectionHeaderProps) => {
  return <header sx={sx} className={className}>
      <h2 sx={styles.title}>{title}</h2>
    </header>;
};
export default SectionHeader;